export default __webpack_public_path__ + "static/media/technology_right.d095b127.png";